import FindologicTracker from './interface';
import func from '../../func';
import network from '../../network';

/**
 * Tracker using AJAX, as a fallback for browsers not supporting the Beacon API.
 *
 * @constructor
 * @augments FindologicTracker
 */
export default function AjaxTracker(config) {
    FindologicTracker.call(this, config);
    /**
     * Sends a tracking request using AJAX.
     *
     * @param {string} url The URL to send the tracking request to.
     * @param {string} data Tracking data to transmit.
     * @param {function} callback The callback that's being called once the request is complete, or after one
     *      second, whichever happens earlier.
     */
    this.send = function (url, data, callback) {
        callback = func.wrapCallbackWithTimeout(func.undefinedToNoOp(callback), FindologicTracker.TIMEOUT);

        network.postJson(url, data, callback);
    };
}
